/** @jsxImportSource @emotion/react */
import React, { useCallback } from 'react'
import { TeamOutlined } from '@ant-design/icons'
import {
  MyTeamOfficial,
  UpcomingGame,
} from '@sportninja/common/types/PlayerAttendance'
import { manageAttendanceButtonOutlinedStyle } from '../styles'
import { trackEvent, getPlatformType } from '../../../utils/analytics'
import { resolveVisitingTeamDisplay } from '@sportninja/common/features/game/placeholderVisitor/resolveVisitingTeamDisplay'

export interface ManageTeamAttendanceProps {
  teamRep: MyTeamOfficial
  rowItem: UpcomingGame
  teamSide: 'home' | 'visitor'
  onPressManageAttendance: (
    gameId: string,
    rosterId: string,
    teamId: string,
    teamName: string,
    showWaiver: boolean
  ) => void
}

const ManageTeamAttendance: React.FC<ManageTeamAttendanceProps> = ({
  teamRep,
  rowItem,
  teamSide,
  onPressManageAttendance,
}) => {
  const handlePress = useCallback(() => {
    trackEvent('home_game_card_manage_attendance_tapped', {
      platform: getPlatformType(),
      game_id: rowItem?.id,
      team_side: teamSide,
    })

    /*
     * Resolved for the visitor so a placeholder game passes the admin-typed
     * name, and `?? ''` because the consumer takes a definite string --
     * `visiting_team` is absent on those games (SN-8410).
     */
    const teamName =
      teamSide === 'home'
        ? rowItem?.home_team?.name ?? ''
        : resolveVisitingTeamDisplay(rowItem).name ?? ''

    onPressManageAttendance(
      rowItem?.id,
      teamRep?.game_player_roster_id,
      teamRep?.team_id,
      teamName,
      rowItem?.show_waiver
    )
  }, [teamRep, rowItem, teamSide, onPressManageAttendance])

  return (
    <button css={manageAttendanceButtonOutlinedStyle} onClick={handlePress}>
      <span>MANAGE ATTENDANCE</span>
      <TeamOutlined style={{ fontSize: 16 }} />
    </button>
  )
}

export default React.memo(ManageTeamAttendance)
